import React from 'react';
import { Create, SimpleForm, ReferenceArrayInput } from 'react-admin';
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
} from '@mui/material';
import { apiKeyCleaner } from '../../utilities/dataProvider/cleaner';
import resourceNames from '../../constants/resourceNames';

const ApiKeyCreate = () => (
  <Create transform={apiKeyCleaner}>
    <Card variant="outlined">
      <CardContent>
        <SimpleForm component={Box}>
          <Grid container spacing={1}>
            <Grid size={12}>
              <Typography>
                Permission Roles
              </Typography>
            </Grid>
            <Grid size={4}>
              <ReferenceArrayInput reference={resourceNames.PERMISSION_ROLES} label="Permission Role" source="permissionRoleIds" />
            </Grid>
          </Grid>
        </SimpleForm>
      </CardContent>
    </Card>
  </Create>
);

export default ApiKeyCreate;
